

















import { AdminRouteName } from '@/constants';
import store from '@/store';
import { IUser, StatusChoices } from '@homeserve/od-typings/api';
import { Nullable } from '@homeserve/od-typings/utils';
import { userHelper } from '@homeserve/vue-api-plugin';
import { authHelper } from '@homeserve/vue-auth-plugin';
import { Component, Vue } from 'vue-property-decorator';
import { RawLocation, Route } from 'vue-router';
import { State } from 'vuex-class';

Component.registerHooks(['beforeRouteEnter']);

@Component
export default class Admin extends Vue {
  @State('user', { namespace: 'api/user/user' })
  public user!: Nullable<IUser>;

  get isPending() {
    const { company } = this.user!;

    return !company || company.status === StatusChoices.PENDING;
  }

  public async beforeRouteEnter(
    to: Route,
    from: Route,
    next: (to?: RawLocation | false | ((vm: Admin) => any) | void) => void,
  ) {
    const previousRouteName = store.getters.previousRouteName;

    if (previousRouteName || (from.name && from.name!.startsWith('onboarding'))) {
      store.commit('previousRouteName', undefined);

      return next();
    }

    store.commit('loading', true);

    const { error } = await userHelper.fetchUser(store);

    store.commit('loading', false);

    if (error) {
      await authHelper.logout(store);

      return next({ name: 'login' });
    }

    next();
  }

  public get AdminRouteName() {
    return AdminRouteName;
  }
}
